import React from "react";
import Step from "./Step";

interface StepperProps {
  steps: string[];
  activeStep: number;
}

export const Stepper: React.FC<StepperProps> = ({ steps, activeStep }) => {
  return (
    <nav aria-label="Progress">
      <ol role="list" className="flex items-center">
        {steps.map((step, idx) => {
          return (
            <Step
              key={idx}
              completed={idx < activeStep}
              current={idx === activeStep}
              upcoming={idx > activeStep}
              isLast={idx === steps.length - 1}
              label={step}
            />
          );
        })}
      </ol>
    </nav>
  );
};
